import React from "react";
import classNames from "classnames";
import { globalConfigFields } from "../../../../../redux/modules/globalConfig";
import UniversalTableCellTypes from "../../../../../lib/UniversalTable/UniversalTableCellTypes";
import { shouldUseNumberWithPriceAlertRenderer } from "../../../../../lib/UniversalTable/RendererHelpers/NumberWithPriceAlertHelper";
import withGlobalConfigFields from "../../../../../hocs/withGlobalConfigFields";
import config from "../../../../../config";

const rendererFactory = ({ attributeName, cellType, format }) => {
  if (shouldUseNumberWithPriceAlertRenderer(format)) {
    return require("./NumberWithPriceAlert").default;
  }

  if (
    attributeName === "breakout" &&
    cellType === UniversalTableCellTypes.date
  ) {
    return require("./BreakoutDate").default;
  }

  if (
    attributeName === "breakdown" &&
    cellType === UniversalTableCellTypes.date
  ) {
    return require("./BreakdownDate").default;
  }

  if (
    attributeName === "confirmation_date" &&
    cellType === UniversalTableCellTypes.date
  ) {
    return require("./ConfirmationDate").default;
  }

  if (
    attributeName === "correction_level" &&
    cellType === UniversalTableCellTypes.number
  ) {
    return require("./CorrectionLevel").default;
  }

  if (attributeName === "current_price" && cellType === UniversalTableCellTypes.number) {
    return require("./FrontEndRenderers/Price").default;
  }

  if (attributeName === "name" && cellType === UniversalTableCellTypes.string) {
    return require("./Name").default;
  }

  return require(`./${cellType}`).default;
};

const Renderer = props => {
  const {
    blurred,
    type,
    value,
    attributeName,
    format,
    globalConfig: { offerUrl }
  } = props;

  const cellType =
    UniversalTableCellTypes[type] || UniversalTableCellTypes["string"];

  const Renderer = rendererFactory({ attributeName, cellType, format });

  let shouldRenderDash = false;

  if (blurred) {
    shouldRenderDash = true;
  } else if (typeof Renderer.shouldRenderDash === "function") {
    shouldRenderDash = Renderer.shouldRenderDash(props);
  } else if (type === "action.price_alert") {
    shouldRenderDash = false;
  } else {
    if (typeof value === "undefined" || value === null) {
      shouldRenderDash = true;
    }

    if (value && typeof value === "string" && value.toLowerCase() === "none") {
      shouldRenderDash = true;
    }
  }

  return (
    <div
      className={classNames({
        "universal-table-lite-renderer": true,
        blurred
      })}
      onClick={() => {
        if (blurred) {
          window.open(offerUrl || config.defaultPremiumOfferUrl, "_blank");
        }
      }}
    >
      {shouldRenderDash ? "-" : <Renderer {...props} />}
    </div>
  );
};

Renderer.defaultProps = {
  blurred: false,
  type: "String"
};

export default withGlobalConfigFields([globalConfigFields.OFFER_URL])(Renderer);
